<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { Component, Vue } from "vue-property-decorator";
// import GsDropHint from "@/pages/home/components/GsDropHint.vue";
// import LonganLoaded from "@/module/objects/longanLoad";
// import { DevModule } from "gs-longan/utility";

export default {
  // methods: {
  //   loadScript(src, isLongan) {
  //     return new Promise((resolve, reject) => {
  //       let script = document.createElement("script");
  //       script.type = "text/javascript";
  //       script.async = true;
  //       script.src = src;
  //       document.head.appendChild(script);
  //       if (isLongan) {
  //         // window.Module = {};
  //         DevModule.onReady = () => {
  //           console.log("onRuntimeInitialized", window);
  //           // this._isLoaded = true
  //           resolve();
  //         };
  //       } else {
  //         resolve();
  //       }
  //       script.onload = () => {
  //         console.log("load" + src);
  //         resolve();
  //         // this.$store.commit("scriptLoaded", true);
  //       };
  //     });
  //   },

  //   async import() {
  //     await this.loadScript("./js/longan/longan.js", true).then(() => {});
  //     await this.loadScript("./js/longan/gs.math.js");
  //     await this.loadScript("./js/longan/gs.collections.js");
  //     await this.loadScript("./js/longan/gs.viewer.js");
  //   },
  // },
  created() {
      window.document.documentElement.setAttribute("data-theme", 'theme-primary')
  },

  mounted() {
    // let script = document.createElement("script");
    // script.type = "text/javascript";
    // script.async = false;
    // script.src = "./js/script.js";
    // script.onload = () => {
    //   this.$store.commit("scriptLoaded", true);
    // };
    // document.head.appendChild(script);
    // this.load();
    // LonganLoaded.getInstance().import();
    // this.import();
    // console.log("App window", window);
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #424242;
}

body {
  margin: 0;
}
</style>
